import { useTradeWasteContext } from "../../../tradeWasteContext";
import { motion } from "framer-motion";


const Unavailable = () => {
  const [tradeWasteContext] = useTradeWasteContext();

  const variants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  }
  return (
    <motion.p
      initial="hidden"
      animate="visible"
      variants={variants}
    >
      <>
        Online application is currently not available for your selection(s),
        please download and complete a blank application form along with any
        business specific supplement forms.{" "}
        <a
          href={tradeWasteContext.blankAppUrl}
          target="_blank"
        >
          Find application forms here
        </a>
      </>
    </motion.p>
  );
};

export default Unavailable;
